import { DANKORT_CARD_TYPE_NAME } from '@/core/payment-card/constants/card-types';

export const DEFAULT_CVV_LENGTH = 3;

/**
 * Use CUSTOM_CVV_LENGTH to override the default limitation of code size not supporting array of numbers.
 * Set the value to key to the name of your card and the value to a number[minLength, maxLength]
 */
export const CUSTOM_CVV_LENGTH = {
    [DANKORT_CARD_TYPE_NAME]: [3, 4]
};
